"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var GlobalProgressContext_1 = require("./GlobalProgressContext");
var classnames_1 = __importDefault(require("classnames"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var useInterval_1 = require("../core/utils/useInterval");
var progressbarColor = function (t) {
    return t.palette.primary.main;
};
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        visibility: 'visible',
        opacity: 1,
        transition: 'all 400ms',
        zIndex: 9999,
    },
    progress: {
        background: progressbarColor(t),
        boxShadow: "0 0 10px " + progressbarColor(t) + ", 0 0 5px " + progressbarColor(t),
        height: 2,
        transition: t.transitions.create('all', { duration: GlobalProgressContext_1.progressbarAnimationDuration }),
    },
    progressHide: {
        height: '0px !important',
    },
}); });
var INITIAL_PERCENT = 10;
var GlobalProgressBar = function (_a) {
    var className = _a.className, style = _a.style, styleProgress = _a.styleProgress;
    var classes = useStyles({});
    var _b = (0, GlobalProgressContext_1.useGlobalProgressState)(), currentStep = _b.currentStep, steps = _b.steps, started = _b.started;
    var _c = (0, react_1.useState)(0), autoIncrement = _c[0], setAutoIncrement = _c[1];
    (0, useInterval_1.useInterval)(function () {
        setAutoIncrement(autoIncrement + 1);
    }, 500);
    (0, react_1.useEffect)(function () {
        setAutoIncrement(0);
    }, [steps, currentStep]);
    var stepProgress = (100 - INITIAL_PERCENT) / steps;
    var percent = Math.min(INITIAL_PERCENT + stepProgress * currentStep + Math.min(autoIncrement, stepProgress), 100);
    return (React.createElement("div", { className: classes.root, style: style },
        React.createElement("div", { className: (0, classnames_1.default)(classes.progress, !started && classes.progressHide), style: __assign(__assign({}, styleProgress), { width: percent + '%' }) })));
};
exports.default = GlobalProgressBar;
//# sourceMappingURL=GlobalProgressBar.js.map